import { render } from "./SolucoesView.vue?vue&type=template&id=ac267c70&scoped=true"
import script from "./SolucoesView.vue?vue&type=script&lang=js"
export * from "./SolucoesView.vue?vue&type=script&lang=js"

import "./SolucoesView.vue?vue&type=style&index=0&id=ac267c70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac267c70"]])

export default __exports__